import { ApiPath } from "enums";
import { Get } from "utils";

export const getNewCustomerVouchers = async (body) => {
  const res = await Get(`${ApiPath.NewCustomerVouchers}`, body);
  return res.data;
};
